<script>
import Alert from 'element-ui/lib/alert';

export default Alert;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/alert.css';
// Adding RTL support to element's alert

.el-alert {
  @include rtl() {
    &__closebtn {
      left: 15px;
      right: auto;
    }
  }

  &__title {
    display: block;
    font-weight: bold;
  }

  &__content {
    padding: $global-padding / 2 $global-padding;
    font-size: 0.9rem;
  }

  &--info {
    a {
      color: $lb-darker-gray;

      &:hover,
      &:focus {
        color: $lb-white;
      }
    }
  }
}
</style>
